export const TOTAL_STEPS = 10

export const ORG_LAST_STEP = 4

export const CARD_FIRST_STEP = 5

export const CARD_STEPS = TOTAL_STEPS - ORG_LAST_STEP

export const CARD_MAX = 3

/**
 * PC 는 모바일 10단계를 4페이지로 묶는다(시안 1288:18993 · 1288:20274 의 "Left Menu").
 * 지금 시안을 받은 것은 앞 두 페이지뿐이다 — 뒤 두 페이지는 이름만 있고 화면은 모바일 단계를 그대로 쓴다.
 */
export const PC_FLOW_STEPS = [
  { key: 'org', label: '기업 등록' },
  { key: 'manager', label: '담당자 입력' },
  { key: 'card-input', label: '해결카드 정보 입력' },
  { key: 'card-select', label: '해결카드 정보 선택' },
] as const

export type PcFlowKey = (typeof PC_FLOW_STEPS)[number]['key']

/** PC 첫 페이지가 묶는 모바일 단계 — 유형 · 기업 정보 · 기업 소개. */
export const PC_ORG_LAST_STEP = 3

/**
 * PC 네 번째 페이지(해결카드 정보 선택)가 **이 단계 다음부터** 모바일 6~10 을 묶는다.
 * 5단계(해결카드 본문 입력)는 PC 시안을 받지 않아 모바일 화면이 그대로 뜬다.
 */
export const PC_CARD_FIRST_STEP = 5

export const CARD_TITLE_MAX = 120
export const CARD_SUMMARY_MAX = 120
export const CARD_TEXT_MAX = 500
export const CARD_ACCESS_MAX = 1000

export const INTRO_MAX = 200

export const LOGO_MAX_BYTES = 2 * 1024 * 1024

export const CONSENTS = [
  { key: 'privacy', label: '[필수] 개인정보 수집·이용에 동의합니다.', detail: true },
] as const

export const HELP_TYPES = [
  { code: 'help_direct_service', label: '직접 서비스 제공' },
  { code: 'help_manpower', label: '인력·자원봉사 지원' },
  { code: 'help_space', label: '공간 제공' },
  { code: 'help_goods', label: '물품·현물 지원' },
  { code: 'help_education', label: '교육·상담' },
  { code: 'help_tech', label: '기술·제작 지원' },
  { code: 'help_bridge', label: '연계·중개' },
  { code: 'help_fund', label: '자금·후원' },
] as const
